/**
 * Get tenant ID from hostname
 */
export function getTenantFromHost(): string | null {
  const hostname = window.location.hostname;
  console.log('🔍 getTenantFromHost - hostname:', hostname);
  
  // Check if this is a production subdomain
  if (hostname.includes('yoursanctuary.ai')) {
    const subdomain = hostname.split('.')[0];
    console.log('🔍 Production subdomain detected:', subdomain);
    return subdomain;
  }
  
  // Development environment - check for preview parameter
  const urlParams = new URLSearchParams(window.location.search);
  const previewParam = urlParams.get('preview');
  if (previewParam) {
    console.log('✅ Found preview parameter:', previewParam);
    return previewParam;
  }
  
  // Default to admin for development/preview
  console.log('✅ Development environment - defaulting to admin');
  return 'admin';
}